module.exports = __webpack_public_path__ + "static/media/tabs-icon-intreractive-objects.cfcc4be5.svg";